/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_login_layout_carousel_title_3 = /** @type {(inputs: {}) => string} */ () => {
	return `Automatiza Pagos a Proveedores y Servicios`
};

const en_login_layout_carousel_title_3 = /** @type {(inputs: {}) => string} */ () => {
	return `Automate Payments to Suppliers and Services`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const login_layout_carousel_title_3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_layout_carousel_title_3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_layout_carousel_title_3", locale)
	if (locale === "es") return es_login_layout_carousel_title_3(inputs)
	return en_login_layout_carousel_title_3(inputs)
};
export { login_layout_carousel_title_3 as "login_layout.carousel.title_3" }